module.exports = __webpack_public_path__ + "img/49.cac11585.jpg";